export function safeParseUrl(url: string): URL | undefined {
    try {
        return new URL(url)
    } catch (error) {
        return undefined
    }
}

/*
 * Base URL for WhatsApp
 * Use WHATS_APP_BASE_URL/<number> where the <number> is a full phone number in international format.
 * Omit any zeroes, brackets, or dashes when adding the phone number in international format.
 *
 * Use: https://wa.me/1XXXXXXXXXX
 * Don't use: https://wa.me/+001-(XXX)XXXXXXX
 */
export const WHATS_APP_BASE_URL = 'https://wa.me/'

export function getWhatsAppLinkHref(whatAppNumber: string) {
    return `${WHATS_APP_BASE_URL}${whatAppNumber.replace('+', '').replace(/ /g, '')}`
}

export const MS_TEAMS_BASE_URL = 'https://teams.microsoft.com/l/chat/0/0?users'

export function getMsTeamsLinkHref(msTeamEmail: string) {
    return `${MS_TEAMS_BASE_URL}=${msTeamEmail}`
}

export function getPhoneNumberLinkHref(protocol: string, phoneNumber: string) {
    return `${protocol}:${phoneNumber.replace(/ /g, '')}`
}
